/*============================================================================
  CART API CALL
==============================================================================*/

const cartUrl = window.themeVariables.routes.cartUrl;

function postToCart(endpoint, body) {
	return fetch(cartUrl + '/' + endpoint + '.js', {
		method: 'POST',
		headers: {'Content-Type': 'application/json'},
		body: JSON.stringify(body)
	});
}


/*============================================================================
  PACKAGE OPTIONS — PARENT MAIN FUNCTION / CALLED FROM theme.js
  INIT FONCTION FOR PACKAGE MANAGEMENT IN CART
==============================================================================*/

function cartPackageManager(element, quantity) {
	let dispatch = cartActionDispatch(element);
	if (dispatch.action == 'nativeAction') {
		return 'nativeAction';
	}

	let packageItems = packageItemsBuilder(dispatch.packageId);

	/* Define real qty targeted */
	let clickedLine = element.closest('line-item');
	let mainPackageItem = packageItems[clickedLine.dataset.variant];
	let newQty = mainPackageItem.quantity - parseInt(clickedLine.dataset.quantity) + quantity;

	let hasStock = checkInventory(packageItems, newQty);
	if (!hasStock) {
		document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
			bubbles: true,
			detail: {status: 'error', error: window.themeVariables.strings.cartNoMoreStock}
		}));
		return 'customAction';
	}

	cartUpdatePackage(packageItems, newQty, dispatch.packageId);
	return 'customAction';
}


/*============================================================================
  PACKAGE OPTIONS — DECIDE WHO HANDLES THE ACTION
==============================================================================*/

function cartActionDispatch(element) {
	/* Check if data wrapper exists for item requested */
	let itemLine = element.closest('line-item');
	if (!itemLine) {
		return {action: 'nativeAction'};
	}

	/* Check if item has a package ID */
	let itemPackageId = itemLine.dataset.package;
	if (!itemPackageId) {
		return {action: 'nativeAction'};
	}

	/* Check if item requested is the main product and not one of its options */
	if (itemLine.dataset.role != 'main') {
		return {action: 'nativeAction'};
	}

	/* Check if two different main products share this package id */
	let mainItemLines = document.querySelectorAll('line-item[data-package="' + itemPackageId + '"][data-role="main"]');
	let mainItemVariant = mainItemLines[0].dataset.variant;
	let hasDifferentMainItems = false;

	for (let i = 0; i < mainItemLines.length; i++) {
		if (mainItemLines[i].dataset.variant != mainItemVariant) {
			hasDifferentMainItems = true;
			break;
		}
	}

	if (hasDifferentMainItems) {
		return {action: 'nativeAction'};
	}

	/* Check if package has at least one option to follow */
	let itemPackageOptions = document.querySelectorAll('line-item[data-package="' + itemPackageId + '"][data-role="option"]');
	if (itemPackageOptions.length < 1) {
		return {action: 'nativeAction'};
	}

	return {action: 'customAction', packageId: itemPackageId};
}


/*============================================================================
  PACKAGE OPTIONS — BUILD RELATED ITEMS OBJECTS INSIDE A SAME PACKAGE WITH NEEDED DATAS
  Each object for grouped items is built with : role, variant id, qty ratio, variant available stock, total qty in cart, line keys for each item
==============================================================================*/

function packageItemsBuilder(packageId) {
	/* 1. Get every line of the package from its id */
	let packageLines = document.querySelectorAll('line-item[data-package="' + packageId + '"]');
	let packageItems = {};

	/* 2. Walk through them one by one */
	packageLines.forEach(function(line) {
		let variant = line.dataset.variant;

		/* 3. No object yet for this variant, create it */
		if (!packageItems[variant]) {
			packageItems[variant] = {
				role: line.dataset.role,
				variant: variant,
				ratio: parseInt(line.dataset.ratio),
				maxStock: line.dataset.maxStock,
				quantity: 0,
				lineKeys: []
			};
		}

		/* 4. Add up the line quantity */
		packageItems[variant].quantity = packageItems[variant].quantity + parseInt(line.dataset.quantity);

		/* 5. Push its line key */
		packageItems[variant].lineKeys.push(line.dataset.lineKey);
	});

	/* 6. Every line has been seen */
	return packageItems;
}


/*============================================================================
  PACKAGE OPTIONS — CHECK STOCK BEFORE SENDING
==============================================================================*/

function checkInventory(packageItems, newQty) {
	let packageItemsList = Object.values(packageItems);
	let available = true;

	for (let i = 0; i < packageItemsList.length; i++) {
		if (packageItemsList[i].maxStock) {
			let wanted = newQty * packageItemsList[i].ratio;

			if (wanted > parseInt(packageItemsList[i].maxStock)) {
				available = false;
				break;
			}
		}
	}

	return available;
}


/*============================================================================
  PACKAGE OPTIONS — SEND THE WHOLE PACKAGE
==============================================================================*/

function cartUpdatePackage(packageItems, newQty, packageId) {
	let updates = {};
	let requestOk = false;

	/* Targeted qty applied to the first line of each item, its other lines emptied */
	Object.values(packageItems).forEach(function(item) {
		item.lineKeys.forEach(function(lineKey, index) {
			if (index == 0) {
				updates[lineKey] = newQty * item.ratio;
			} else {
				updates[lineKey] = 0;
			}
		});
	});

	let loaders = document.querySelectorAll('line-item[data-package="' + packageId + '"] .line-item__loader');

	loaders.forEach(function(loader) {
		loader.hidden = false;
		loader.firstElementChild.hidden = false;
	});

	postToCart('update', {updates: updates})
		.then(function(response) {
			requestOk = response.ok;
			return response.json();
		})
		.then(function(content) {
			loaders.forEach(function(loader) {
				loader.hidden = true;
			});

			if (!requestOk) {
				document.documentElement.dispatchEvent(new CustomEvent('cart-notification:show', {
					bubbles: true,
					detail: {status: 'error', error: content.description}
				}));
				return;
			}

			document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
				bubbles: true,
				detail: {cart: content}
			}));

			document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
				bubbles: true,
				detail: {cart: content}
			}));
		})
		.catch(function(error) {
			console.error('Error:', error);
		});
}


/*============================================================================
  FREE GIFT — APPLY WHAT LIQUID ASKED FOR
==============================================================================*/

function updateFreeGifts() {
	let updates = {};
	let items = [];

	document.querySelectorAll('free-product-data[data-action]').forEach(node => {
		let action = node.dataset.action;
		let variant = node.dataset.variant;

		if (action == 'remove' || action == 'claim') {
			updates[node.dataset.lineKey] = 0;
		}

		if (action == 'add' || action == 'claim') {
			items.push({
				id: variant,
				quantity: parseInt(node.dataset.qty, 10),
				properties: {[node.dataset.prop]: node.dataset.block}
			});
		}
	});

	if (!Object.keys(updates).length && !items.length) {
		return;
	}

	let request = Promise.resolve();

	if (Object.keys(updates).length) {
		request = request.then(() => postToCart('update', {updates: updates}));
	}

	if (items.length) {
		request = request.then(() => postToCart('add', {items: items}));
	}

	request
		.then(refreshCart)
		.catch((error) => {
			console.error('Error:', error);
		});
}


/*============================================================================
  FREE GIFT — CUSTOMER TICKS OR UNTICKS THE BOX
==============================================================================*/

function toggleFreeGift(event) {
	let input = event.target;
	let wanted = input.checked;
	let block = input.closest('free-gift');
	let loader = block.querySelector('.line-item__loader');
	let attributes = {};

	/* The box only reflects the cart, never the click itself */
	event.preventDefault();

	if (wanted) {
		attributes['_free_gift|' + input.dataset.block] = '';
	} else {
		attributes['_free_gift|' + input.dataset.block] = 'declined';
	}

	if (loader) {
		loader.hidden = false;
		loader.firstElementChild.hidden = false;
	}

	let cartUpdate = {attributes: attributes};

	if (!wanted) {
		cartUpdate.updates = {[input.dataset.lineKey]: 0};
	}

	postToCart('update', cartUpdate)
		.then(refreshCart)
		.catch((error) => {
			console.error('Error:', error);
		});
}


/*============================================================================
  FREE GIFT — WATCH DRAWER REPLACEMENT
==============================================================================*/

var freeGiftObserver;

function watchFreeGiftDrawer() {
	let drawer = document.getElementById('mini-cart');

	if (!drawer || freeGiftObserver) {
		return;
	}

	freeGiftObserver = new MutationObserver(() => {
		freeGiftObserver.disconnect();
		freeGiftObserver = null;
		updateFreeGifts();
	});

	freeGiftObserver.observe(drawer, {childList: true});
}


/*============================================================================
  FREE GIFT — ASK THE DRAWER TO RENDER AGAIN
==============================================================================*/

function refreshCart() {
	document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
		bubbles: true
	}));
}


/*============================================================================
  FREE GIFT - INIT
==============================================================================*/

document.addEventListener('click', (event) => {
	if (event.target.matches('.free-gift--check-input')) {
		toggleFreeGift(event);
	}
});

document.documentElement.addEventListener('cart:refresh', watchFreeGiftDrawer);

updateFreeGifts();

if (window.themeVariables.settings.pageType == 'cart') {
	let header = document.querySelector('.shopify-section--header');

	/* Header height vars are unreliable here, so we measure where the header actually ends */
	document.documentElement.style.setProperty('--cart-page-top', header.getBoundingClientRect().bottom + 'px');
	document.getElementById('mini-cart').open = true;

	let backdrop = document.querySelector('.cart-page-backdrop');

	if (backdrop) {
		backdrop.classList.add('cart-page-backdrop--gone');
	}
}
